import { useMutation } from "@tanstack/react-query";
import { SupportCaseService } from "@/services/support/supportCaseService";

export function useSupportVehicleLookup() {
  const lookupMutation = useMutation({
    mutationFn: (registrationNo: string) =>
      SupportCaseService.lookupComplaintVehicle(registrationNo),
  });

  return {
    lookupComplaintVehicleAsync: lookupMutation.mutateAsync,
    isLookingUp: lookupMutation.isPending,
  };
}
